import { render, staticRenderFns } from "./carportUser.vue?vue&type=template&id=a00485be&"
import script from "./carportUser.vue?vue&type=script&lang=js&"
export * from "./carportUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports